import React from 'react';
import { useAsync } from "react-async"

import {validate_m, validate_k, validate_r} from "./uvalidation"

const gamma = require('gamma')

export function get_nbd(m,k,r) {

  if (!validate_m(m)) {
    console.log("validate m success.")
  } else {
    console.log("validate m failure.")
  }

  if (!validate_k(k)) {
    console.log("validate k success.")
  } else {
    console.log("validate k failure.")
  }

  if (!validate_r(r)) {
    console.log("validate r success.")
  } else {
    console.log("validate r failure.")
  }

  validate_k(m)
  validate_r(m)

  let _temp = (1 + m / k)**(-k) * gamma(k + r) * (m / (m + k))**r / gamma(r + 1) / gamma(k);

  console.log("")
  console.log("m     : " + m)
  console.log("k     : " + k)
  console.log("r     : " + r)
  // console.log("_temp : " + _temp)
  // console.log("_temp : " + (1 + m / k)**(-k) * gamma(k + r) * (m / (m + k))**r / gamma(r + 1) / gamma(k))
  return _temp
}


// function nbd(m,k,r) {
//   return "default";
// }

// export default nbd;
//
//
